import {
    ADDRESSBYGOOGLE_COLUMN_URI,
    AUTOCOMPLETEFROMENUMERATION_COLUMN_URI,
    AUTOCOMPLETEFROMURI_COLUMN_URI,
    AUTOCOMPLETEWITHGIVENOPTIONS_COLUMN_URI,
    CATEGORYSELECT_URI,
    CHECKBOX_COLUMN_URI,
    CHIPLIST_COLUMN_URI,
    CODEBARSCANNERWITHSELECT_URI,
    CODEBAR_SCANNER_URI,
    COLOR_COLUMN_URI,
    COMPLEXTOTAL_COLUMN_URI,
    COMPLEXUNIQUEINDEX_COLUMN_URI,
    COMPLEX_MASK_URI,
    DATEPICKER_COLUMN_URI,
    DATERANGEPICKER_COLUMN_URI,
    DATETIMEPICKER_COLUMN_URI,
    DTypeCol,
    EMBEDDED_COLLECTION_COLUMN_URI,
    EMBEDDED_ITEM_COLUMN_URI,
    FIELDCHIPLIST_COLUMN_URI,
    FILE_COLUMN_URI,
    FORMATTEDTEXT_COLUMN_URI,
    ICON_COLUMN_URI,
    IMAGE_COLUMN_URI,
    INTEGER_COLUMN_URI,
    LANGUAGETEXTAREA_COLUMN_URI,
    LANGUAGETEXT_COLUMN_URI,
    MULTIIMAGE_COLUMN_URI,
    RADIO_COLUMN_URI,
    RATING_COLUMN_URI,
    REAL_COLUMN_URI,
    SECTION_COLUMN_URI,
    SELECTFACADE_COLUMN_URI,
    SELECTFROMCONCEPTSERVICE_COLUMN_URI,
    SELECTFROMENUMERATION_COLUMN_URI,
    SELECTFROMMASTERDATA_COLUMN_URI,
    SELECTFROMURI_COLUMN_URI,
    SELECTMASTER_COLUMN_URI,
    SELECTFROMNEXTSERVICIOPLANNINGAREA_COLUMN_URI,
    SELECTNEXTTASKTYPE_COLUMN_URI,
    SELECTSERVICEUSERASSIGNMENT_COLUMN_URI,
    SELECTSERVICE_COLUMN_URI,
    SELECTWITHGIVENOPTIONS_COLUMN_URI,
    SMILEYS_COLUMN_URI,
    SUBSECTION_COLUMN_URI,
    SUMMARY_MASK_URI,
    TABLEWITHFIXEDROWS_URI,
    TABLEWITHVARIABLEROWS_URI,
    TABLE_COLUMN_URI,
    TEXTAREA_COLUMN_URI,
    TEXTMASK_COLUMN_URI,
    TEXT_COLUMN_URI,
    TIMEPICKER_COLUMN_URI,
    TIMERANGESCONVERTER_COLUMN_URI,
    TRISTATE_COLUMN_URI,
    TWOCOLUMNSTABLE_URI,
    USERPROFILECHIPLIST_COLUMN_URI,
    WYSIWYG_COLUMN_URI,
    RATINGLINKEDTOTABLE_URI,
    TABLEWITHRATINGLINKED_URI,
    SIGNATURE_COLUMN_URI,
    USERSELECT_COLUMN_URI,
    AUTOCOMPLETE_FROM_MASTER_DATA,
} from '@grupo-constant/next-dtype/types';
import { DTypeAddressFieldComponent } from './fields/address-field/address-field.component';
import { DtypeAutocompleteFieldComponent } from './fields/autocomplete-field/autocomplete-field.component';
import { DtypeCategorySelectFieldComponent } from './fields/categoryselect-field/category-select-field.component';
import { DtypeCheckboxFieldComponent } from './fields/checkbox-field/checkbox-field.component';
import { DtypeChiplistFieldComponent } from './fields/chiplist-field/chiplist-field.component';
import { DtypeCodebarScannerFieldComponent } from './fields/codebar-scanner-field/codebar-scanner-field.component';
import { DtypeCollectionFieldComponent } from './fields/collection-field/collection-field.component';
import { DtypeColorFieldComponent } from './fields/color-field/color-field.component';
import { DtypeComplexMaskFieldComponent } from './fields/complex-mask-field/complex-mask-field.component';
import { DtypeComplexTotalFieldComponent } from './fields/complex-total-field/complex-total-field.component';
import { DtypeComplexUniqueIndexFieldComponent } from './fields/complex-unique-index-field/complex-unique-index-field.component';
import { DtypeDatepickerFieldComponent } from './fields/datepicker-field/datepicker-field.component';
import { DtypeDaterangepickerFieldComponent } from './fields/daterangepicker-field/daterangepicker-field.component';
import { DtypeDatetimepickerFieldComponent } from './fields/datetimepicker-field/datetimepicker-field.component';
import { DtypeFieldChiplistFieldComponent } from './fields/field-chiplist-field/field-chiplist-field.component';
import { DtypeFileFieldComponent } from './fields/file-field/file-field.component';
import { DtypeFreetextFieldComponent } from './fields/freetext-field/freetext-field.component';
import { DtypeIconFieldComponent } from './fields/icon-field/icon-field.component';
import { DtypeImageFieldComponent } from './fields/image-field/image-field.component';
import { DtypeItemFieldComponent } from './fields/item-field/item-field.component';
import { DtypeLocaleTextFieldComponent } from './fields/localetext-field/localetext-field.component';
import { DtypeMultiImageFieldComponent } from './fields/multiimage-field/multiimage-field.component';
import { DtypeNumberFieldComponent } from './fields/number-field/number-field.component';
import { DtypeRadioFieldComponent } from './fields/radio-field/radio-field.component';
import { DtypeRatingFieldComponent } from './fields/rating-field/rating-field.component';
import { DtypeSelectFieldComponent } from './fields/select-field/select-field.component';
import { DtypeSelectGroupFieldComponent } from './fields/select-group-field/select-group-field.component';
import { DtypeSignatureFieldComponent } from './fields/signature-field/signature-field.component';
import { DtypeSmileysFieldComponent } from './fields/smileys-field/smileys-field.component';
import { DtypeSummaryMaskFieldComponent } from './fields/summary-mask-field/summary-mask-field.component';
import { DtypeTableFieldComponent } from './fields/table-field/table-field.component';
import { DtypeTableWithFixedRowsFieldComponent } from './fields/tablewithfixedrows-field/tablewithfixedrows-field.component';
import { DtypeTableWithVariableRowsFieldComponent } from './fields/tablewithvariablerows-field/tablewithvariablerows-field.component';
import { DtypeTextFieldComponent } from './fields/text-field/text-field.component';
import { DtypeTextMaskFieldComponent } from './fields/text-mask-field/text-mask-field.component';
import { DtypeTimepickerFieldComponent } from './fields/timepicker-field/timepicker-field.component';
import { DtypeTimeRangesConverterFieldComponent } from './fields/timerangesconverter-field/timerangesconverter-field.component';
import { DtypeTristateFieldComponent } from './fields/tristate-field/tristate-field.component';
import { DtypeTwoColumnsTableFieldComponent } from './fields/two-columns-table/twocolumnstable-field.component';
import { DtypeUserProfileChiplistFieldComponent } from './fields/user-profile-chiplist-field/user-profile-chiplist-field.component';
import { DtypeUserSelectFieldComponent } from './fields/user-select-field/user-select-field.component';
import { DtypeWYSIWYGFieldComponent } from './fields/wysiwyg-field/wysiwyg-field.component';

export class DtypeFieldsRegistry {

    static components: Record<string, any> = {
        address: DTypeAddressFieldComponent,
        autocomplete: DtypeAutocompleteFieldComponent,
        categoryselect: DtypeCategorySelectFieldComponent,
        checkbox: DtypeCheckboxFieldComponent,
        chiplist: DtypeChiplistFieldComponent,
        codebarscanner: DtypeCodebarScannerFieldComponent,
        collection: DtypeCollectionFieldComponent,
        color: DtypeColorFieldComponent,
        complexmask: DtypeComplexMaskFieldComponent,
        complexuniqueindex: DtypeComplexUniqueIndexFieldComponent,
        complextotalfield: DtypeComplexTotalFieldComponent,
        datepicker: DtypeDatepickerFieldComponent,
        daterangepicker: DtypeDaterangepickerFieldComponent,
        datetimepicker: DtypeDatetimepickerFieldComponent,
        fieldchiplist: DtypeFieldChiplistFieldComponent,
        file: DtypeFileFieldComponent,
        freetext: DtypeFreetextFieldComponent,
        icon: DtypeIconFieldComponent,
        image: DtypeImageFieldComponent,
        item: DtypeItemFieldComponent,
        localetext: DtypeLocaleTextFieldComponent,
        multiimage: DtypeMultiImageFieldComponent,
        numeric: DtypeNumberFieldComponent,
        radio: DtypeRadioFieldComponent,
        rating: DtypeRatingFieldComponent,
        select: DtypeSelectFieldComponent,
        selectgroup: DtypeSelectGroupFieldComponent,
        signature: DtypeSignatureFieldComponent,
        smileys: DtypeSmileysFieldComponent,
        summarymask: DtypeSummaryMaskFieldComponent,
        table: DtypeTableFieldComponent,
        tablewithfixedrows: DtypeTableWithFixedRowsFieldComponent,
        tablewithvariablerows: DtypeTableWithVariableRowsFieldComponent,
        text: DtypeTextFieldComponent,
        textmask: DtypeTextMaskFieldComponent,
        timepicker: DtypeTimepickerFieldComponent,
        timerangesconverter: DtypeTimeRangesConverterFieldComponent,
        tristate: DtypeTristateFieldComponent,
        twocolumnstable: DtypeTwoColumnsTableFieldComponent,
        userselect: DtypeUserSelectFieldComponent,
        userprofilechiplist: DtypeUserProfileChiplistFieldComponent,
        wysiwyg: DtypeWYSIWYGFieldComponent,
    };

    static getFieldType(column: DTypeCol): string {
        switch (column.type) {
            case TEXT_COLUMN_URI:
            case TEXTAREA_COLUMN_URI:
                return 'text';
            case TEXTMASK_COLUMN_URI:
                return 'textmask';
            case COMPLEXUNIQUEINDEX_COLUMN_URI:
                return 'complexuniqueindex';
            case COMPLEXTOTAL_COLUMN_URI:
                return 'complextotalfield';
            case COMPLEX_MASK_URI:
                return 'complexmask';
            case SUMMARY_MASK_URI:
                return 'summarymask';
            case LANGUAGETEXT_COLUMN_URI:
            case LANGUAGETEXTAREA_COLUMN_URI:
                return 'localetext';
            case INTEGER_COLUMN_URI:
            case REAL_COLUMN_URI:
                return 'numeric';
            case CHECKBOX_COLUMN_URI:
                return 'checkbox';
            case RADIO_COLUMN_URI:
                return 'radio';
            case TRISTATE_COLUMN_URI:
                return 'tristate';
            case SELECTFROMCONCEPTSERVICE_COLUMN_URI:
            case SELECTFROMENUMERATION_COLUMN_URI:
            case SELECTFROMURI_COLUMN_URI:
            case SELECTWITHGIVENOPTIONS_COLUMN_URI:
            case SELECTFROMMASTERDATA_COLUMN_URI:
            case CODEBARSCANNERWITHSELECT_URI:
                return 'select';
            case SELECTMASTER_COLUMN_URI:
            case SELECTFACADE_COLUMN_URI:
            case SELECTFROMNEXTSERVICIOPLANNINGAREA_COLUMN_URI:
            case SELECTNEXTTASKTYPE_COLUMN_URI:
            case SELECTSERVICE_COLUMN_URI:
            case SELECTSERVICEUSERASSIGNMENT_COLUMN_URI:
                return 'selectgroup';
            case EMBEDDED_COLLECTION_COLUMN_URI:
                return 'collection';
            case EMBEDDED_ITEM_COLUMN_URI:
                return 'item';
            case AUTOCOMPLETEFROMENUMERATION_COLUMN_URI:
            case AUTOCOMPLETEWITHGIVENOPTIONS_COLUMN_URI:
            case AUTOCOMPLETEFROMURI_COLUMN_URI:
            case AUTOCOMPLETE_FROM_MASTER_DATA:
                return 'autocomplete';
            case DATEPICKER_COLUMN_URI:
                return 'datepicker';
            case DATETIMEPICKER_COLUMN_URI:
                return 'datetimepicker';
            case TIMEPICKER_COLUMN_URI:
                return 'timepicker';
            case DATERANGEPICKER_COLUMN_URI:
                return 'daterangepicker';
            case CHIPLIST_COLUMN_URI:
                return 'chiplist';
            case USERSELECT_COLUMN_URI:
                return 'userselect';
            case USERPROFILECHIPLIST_COLUMN_URI:
                return 'userprofilechiplist';
            case FIELDCHIPLIST_COLUMN_URI:
                return 'fieldchiplist';
            case WYSIWYG_COLUMN_URI:
                return 'wysiwyg';
            case FORMATTEDTEXT_COLUMN_URI:
            case SECTION_COLUMN_URI:
            case SUBSECTION_COLUMN_URI:
                return 'freetext';
            case IMAGE_COLUMN_URI:
                return 'image';
            case MULTIIMAGE_COLUMN_URI:
                return 'multiimage';
            case SIGNATURE_COLUMN_URI:
                return 'signature';
            case FILE_COLUMN_URI:
                return 'file';
            case COLOR_COLUMN_URI:
                return 'color';
            case ICON_COLUMN_URI:
                return 'icon';
            case ADDRESSBYGOOGLE_COLUMN_URI:
                return 'address';
            case TIMERANGESCONVERTER_COLUMN_URI:
                return 'timerangesconverter';
            case TABLEWITHFIXEDROWS_URI:
                return 'tablewithfixedrows';
            case TABLEWITHVARIABLEROWS_URI:
                return 'tablewithvariablerows';
            case TABLE_COLUMN_URI:
                return 'table';
            case TABLEWITHRATINGLINKED_URI:
                return 'tablewithratinglinked';
            case CATEGORYSELECT_URI:
                return 'categoryselect';
            case CODEBAR_SCANNER_URI:
                return 'codebarscanner';
            case TWOCOLUMNSTABLE_URI:
                return 'twocolumnstable';
            case RATING_COLUMN_URI:
                return 'rating';
            case RATINGLINKEDTOTABLE_URI:
                return 'ratinglinkedtotable';
            case SMILEYS_COLUMN_URI:
                return 'smileys';
        }
    }

    static getFieldComponent(fieldType: string): any {
        return this.components[fieldType];
    }
}
